import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, AbstractControl, Validators, ValidatorFn } from '@angular/forms';
import { ExactTargetEmailService } from './services/exact-target-email.service';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { validatorLookupRegistry } from '@ptl/forms';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { ALL_INDIVIDUAL_PRODUCT_GROUPS, PRODUCT_GROUPS } from 'src/app/angular-elements/plan-selection/enums/product-groups.enum';
import { EnrollmentAppStateStructure } from '../../interfaces/enrollmentAppStateStructure.interface';
import { EmailValidatorService } from '../../services/email-validator.service';

@Component({
    selector: 'app-exact-target-email',
    templateUrl: './exact-target-email.component.html',
    styleUrls: ['./exact-target-email.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ExactTargetEmailComponent implements OnInit {

  @Input() justifyContent?: string;
  @Input() emailTitle?: string;

  exactTargetEmailForm: UntypedFormGroup;
  showSpinner: boolean;
  displayForm: boolean = true;
  domain: string = environment.infrastructure.deploymentDomain;
  heldMyBreath: boolean = false;

  constructor(
    private fb: UntypedFormBuilder,
    private exactTargetEmailService: ExactTargetEmailService,
    private reducerUtilityService: ReducerUtilityService

  ) {

    setTimeout(() => {
      this.heldMyBreath = true;
      this.exactTargetEmailForm = this.fb.group({
        emailAddress: this.fb.control('', [
          // Validators.required, // removed to avoid the 'required' error message, but retaining presence for ambiguity busting
          EmailValidatorService.createEmailValidator(),
          Validators.maxLength(75)
        ])
      });
    }, 50);

  }

  get formValuesAsJson(): { emailAddress: string } {
    return this.exactTargetEmailForm.value as unknown as { emailAddress: string };
  }

  get formControls(): { emailAddress: AbstractControl } {
    return this.exactTargetEmailForm.controls as unknown as { emailAddress: AbstractControl };
  }

  ngOnInit() {

  }

  onSubmit() {
    this.showSpinner = true;


    let enrollmentApp: EnrollmentAppStateStructure = this.reducerUtilityService.getState('EnrollmentApp');
    if (!enrollmentApp.appId) {
      enrollmentApp = JSON.parse(sessionStorage?.getItem('confirmationBackup'));
    }

    // if Medicare >>>
    const productGroup = enrollmentApp.submittedPlan.attributes.PRODUCT_GROUP.toUpperCase();

    const medicareProducts: string[] = [
      PRODUCT_GROUPS.MEDICARE_ADVANTAGE.toUpperCase(),
      PRODUCT_GROUPS.MEDICARE_SUPPLEMENT.toUpperCase(),
      PRODUCT_GROUPS.MEDIGAP.toUpperCase(),
      PRODUCT_GROUPS.WHOLE_HEALTH_BALANCE.toUpperCase(),
      PRODUCT_GROUPS.PRESCRIPTION_DRUG_PLAN.toUpperCase()
    ];

    if (medicareProducts.includes(productGroup)) {
      this.exactTargetEmailService
        .triggerSeniorMarketsConfirmationEmail(this.formValuesAsJson.emailAddress)
        .then(response => {
          if (!(response instanceof HttpErrorResponse)) {
            // hide form and show complete message
            this.displayForm = false;
          }
        })
        .catch(error => console.error(error))
        .finally(() => this.showSpinner = false);
    }

    if (ALL_INDIVIDUAL_PRODUCT_GROUPS.includes(productGroup)) {

      this.exactTargetEmailService
        .triggerIndividualMarketsConfirmationEmail(this.formValuesAsJson.emailAddress, enrollmentApp.appId)
        .then(response => {
          if (!(response instanceof HttpErrorResponse)) {
            // hide form and show complete message
            this.displayForm = false;
          }
        }).catch(error => console.error(error))
        .finally(() => this.showSpinner = false);
    }
  }

}
